if (!customElements.get("side-cart")) {
  customElements.define(
    "side-cart",
    class SideCart extends HTMLElement {
      constructor() {
        super();

        this.cartOverlay = this.querySelector(".side-cart__overlay");
        this.closeBtn = this.querySelector(".side-cart__close");
        this.continueShopping = this.querySelector(".continue-shopping-btn");
        this.secureCheckouts = this.querySelectorAll(".secure-checkout-btn");
        this.quickshopClicked = null;

        this.FREESHIPPING = this.dataset.freeShippingThreshold;
        console.log("this.FREESHIPPING", this.FREESHIPPING);
        this.stickyHeader = document.querySelector("sticky-header");
        this.shippingContainer = this.querySelector(".side-cart__shipping-info");

        this.initCart();
      }

      initCart() {
        this.secureCheckouts.forEach((btn) => {
          btn.addEventListener("click", (event) => zonosCheckout(event));
        });
        if (this.cartOverlay) {
          this.cartOverlay.addEventListener("click", this.closeCart.bind(this));
        }
        if (this.closeBtn) {
          this.closeBtn.addEventListener("click", this.closeCart.bind(this));
        }
        if (this.continueShopping) {
          this.continueShopping.addEventListener("click", this.closeCart.bind(this));
        }

        $(document).on("cart.requestComplete", (event, cart) => {
          this.changeQty(cart);
          this.renderShippingMsg(cart);
          this.stickyHeader.renderSecurePanel(cart, this.FREESHIPPING);

          if (this.quickshopClicked) {
            // if(this.quickshopClicked.classList.contains("quickbuy")) {
            // this.quickshopClicked = null;
            // if(!((z_store.live || zTestModeParam || zTestModeCookie) && znIsCountryDomestic())) {
            //   location.href = "/checkout";
            // } else {
            //   zonosCheckout();
            // }
            // } else {
            this.quickshopClicked = null;
            this.openCart();
            // }
          } else {
            this.openCart();

            if (document.querySelector(".pdp__shipping-info")) {
              this.renderPdpShippingMsg(cart);
            }
          }
        });
      }
      handleAddItem(event, quickbuyBtn, variant = null, quantity = 1, properties = {}) {
        this.quickshopClicked = quickbuyBtn;
        var variantId;
        if (variant) variantId = variant;
        else variantId = quickbuyBtn.dataset.variantId;
        CartJS.addItem(variantId, quantity, properties);
      }
      openCart() {
        this.classList.add("cart--open");
      }
      closeCart() {
        this.classList.remove("cart--open");
      }
      changeQty(cart) {
        const totalItems = cart.item_count;
        this.stickyHeader.cartCount.innerHTML = `\(${totalItems}\)`;
        this.stickyHeader.cartCountAlt.forEach((countIndicator) => {
          countIndicator.innerHTML = totalItems > 0 ? totalItems : "";
        });
        var cartIcon = document.getElementById("cart-icon-bubble");

        if (cartIcon && cart.item_count > 0) {
          cartIcon.classList.add("indicator");
        }
        console.log("changeqty in effect");
      }
      renderShippingMsg(cart) {
        const currentTotal = cart.items_subtotal_price;
        const shippingMsg = `
        <a class="pdp__free-shipping" href="/collections/all">
          ${
            currentTotal >= this.FREESHIPPING
              ? "You qualify for free shipping!"
              : `You're <span class="money">
               $${parseFloat((this.FREESHIPPING - currentTotal) / 100).toFixed(2)}
             </span> away from free shipping!`
          }
        </a>
      `;

        this.shippingContainer.innerHTML = shippingMsg;
      }

      renderPdpShippingMsg(cart) {
        const currentTotal = cart.items_subtotal_price;

        const pdpShippingBarWidth =
          currentTotal >= this.FREESHIPPING
            ? 100
            : parseFloat((currentTotal / this.FREESHIPPING) * 100).toFixed(2);
        const pdpShippingMsg = `
        <div class="pdp__free-shipping">
          ${
            currentTotal >= this.FREESHIPPING
              ? "You qualify for free shipping!"
              : `You're <span class="money">
               $${parseFloat((this.FREESHIPPING - currentTotal) / 100).toFixed(2)}
             </span> away from free shipping!`
          }
        </div>
        <div class="pdp_free-shipping-bar">
          <div class="pdp_free-shipping-bar-current" style="width: ${pdpShippingBarWidth}%;">
          </div>
        </div>
        <div class="pdp_free-shipping-bar-values">
          <span>$0</span>
          <span>$150</span>
        </div>
      `;

        document.querySelector(".pdp__shipping-info").innerHTML = pdpShippingMsg;
      }
    }
  );
}
